module.exports = __webpack_public_path__ + "img/t2-7.be10dfc5.svg";